import { Action, createReducer, on } from '@ngrx/store';
import { ISalesState } from '../../utils/interfaces/store.interfaces';
import { clearPermissionDataAction } from '../actions/app.actions';
import { getAuthInfoSalesFailedAction, getAuthInfoSalesSuccessAction, getDocumentsFailedAction, getDocumentsSuccessAction, getNewsFailedAction, getNewsSuccessAction, getPriceListsFailedAction, getPriceListsSuccessAction } from '../actions/sales.actions';

const initialState: ISalesState = {
  permission: null,
  news: null,
  priceLists: null,
  documents: null,
};

export const salesReducerImplicit = createReducer(
  initialState,
  on(getAuthInfoSalesSuccessAction, (state, { data: permission }) => ({
    ...state,
    permission,
  })),
  on(getAuthInfoSalesFailedAction, (state) => ({
    ...state,
    permission: null,
  })),
  on(clearPermissionDataAction, (state) => ({
    ...state,
    permission: null,
  })),
  on(getNewsSuccessAction, (state, { data: news }) => ({
    ...state,
    news,
  })),
  on(getNewsFailedAction, (state) => ({
    ...state,
    news: null,
  })),
  on(getPriceListsSuccessAction, (state, { data: priceLists }) => ({
    ...state,
    priceLists,
  })),
  on(getPriceListsFailedAction, (state) => ({
    ...state,
    priceLists: null,
  })),
  on(getDocumentsSuccessAction, (state, { data: documents }) => ({
    ...state,
    documents,
  })),
  on(getDocumentsFailedAction, (state) => ({
    ...state,
    documents: null,
  })),
);

export function salesReducer(state: any, action: Action): ISalesState {
  return salesReducerImplicit(state, action);
}
